import { render } from "./adminlist.vue?vue&type=template&id=ed79851c"
import script from "./adminlist.vue?vue&type=script&lang=js"
export * from "./adminlist.vue?vue&type=script&lang=js"

import exportComponent from "F:\\chatpc\\chatadmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__